// main:  erscheint in der Desktop-Navigation (mit kurzem Namen "short")
// legal: erscheint im Handy-Menü und im Footer klein unten
const MenuItems = () => {
    const menuItems = [
        { title: "Home", short: "Home", url: "/", main: true },
        { title: "Leistungen", short: "Werkstatt", url: "/werkstatt-service", main: true },
        { title: "Fahrzeuge An- & Verkaufen", short: "An- & Verkauf", url: "/fahrzeugkaufen", main: true },
        { title: "Kontakt", short: "Kontakt", url: "/kontakt", main: true },
        { title: "Impressum", url: "/impressum", legal: true },
        { title: "Datenschutz", url: "/datenschutz", legal: true },
    ];

    return menuItems;
};

export default MenuItems;
